import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { modKey } from "./keys";
import { useUIFlags } from "./UIFlags";
import { usePhone } from "./usePhone";

type Tip = {
    keys: string;
    text: string;
};

const shortcuts: Tip[] = [
    { keys: modKey + " K", text: "Search tasks" },
    { keys: "?", text: "Show this help" },
    { keys: modKey + " Enter", text: "Send a comment" },
    { keys: "Enter", text: "Add a task from a calendar day, then type the next one" },
    { keys: "Esc", text: "Close the add field" },
];

const mouse: Tip[] = [
    { keys: "Drag", text: "Move a task to a different day, or from Unscheduled onto the calendar" },
    { keys: "Right-click", text: "Complete, move to today, copy the link or archive a task" },
    { keys: "New task ▾", text: "Make a chain of tasks that follow each other" },
];

const gestures: Tip[] = [
    { keys: "Swipe right", text: "Complete a task, or open it again" },
    { keys: "Touch and hold", text: "Complete, move to today, copy the link or archive a task" },
    { keys: "Drag the grip", text: "Change the order of the tasks in a day" },
    { keys: "Swipe up", text: "On the Projects bar: see projects and tasks with no date" },
];

// HelpDialog lists the shortcuts and gestures that have no button of their own
export function HelpDialog(props: { open: boolean; onClose: () => void }) {
    const phone = usePhone();
    const flags = useUIFlags();

    return (
        <Dialog open={props.open} onClose={props.onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Shortcuts and tips</DialogTitle>
            <DialogContent>
                {phone ? (
                    <TipList title="Gestures" tips={gestures} />
                ) : (
                    <>
                        <TipList title="Keyboard" tips={shortcuts} />
                        <TipList title="Mouse" tips={mouse} />
                    </>
                )}
            </DialogContent>
            <DialogActions>
                <Button color="inherit" onClick={() => {
                    props.onClose();
                    flags.set("welcome", false);
                }}>
                    Show the intro again
                </Button>
                <Box sx={{ flex: 1 }} />
                <Button onClick={props.onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
}

function TipList(props: { title: string; tips: Tip[] }) {
    return (
        <Box sx={{ mb: 2 }}>
            <Typography variant="overline" color="text.secondary">{props.title}</Typography>
            {props.tips.map(tip => (
                <Box key={tip.keys} sx={{ display: "flex", alignItems: "baseline", gap: 2, py: 0.5 }}>
                    <Box component="kbd" sx={{
                        flexShrink: 0,
                        minWidth: 110,
                        fontFamily: "inherit",
                        fontSize: 12,
                        fontWeight: 600,
                    }}>
                        {tip.keys}
                    </Box>
                    <Typography variant="body2">{tip.text}</Typography>
                </Box>
            ))}
        </Box>
    );
}
